export const drawerWidthExpanded = 246;
export const drawerWidthExpandedMobile = 250;
export const drawerWidth = 90;
export const drawerNestedMenuWidth = 300;
export const navigationBarHeight = 64;
export const appLoaderHeight = 4;
export const savedAccountsLimit = 5;
